import React from 'react'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { measurements } from '@mobi/component-library/Foundations'
import { KAMBI_CLIENT_DIV_ID, KAMBI_CSS_HIDDEN_CLASS } from '@core/Areas/KambiClient/constants'
import { useNewSportsOfferingFeature } from '@core/Areas/KambiSports/Offering/hooks/useNewSportsOfferingFeature'
import { selectIsClientVisible } from '../../Store/selectors'

/** Main component to render Kambi client - NOT within react-router routes */
export const KambiClient: React.FC = React.memo(() => {
  const isKambiClientVisible = useSelector(selectIsClientVisible)
  const isKambiSportsOfferingEnabled = useNewSportsOfferingFeature()

  return (
    <WrapperStyled
      className='mobi__z-stack-bottom mobi__unset-globals'
      style={isKambiClientVisible ? undefined : { display: 'none' }}
      data-hide-kambi-menu={isKambiSportsOfferingEnabled ? 'true' : 'false'}
    >
      <div id={KAMBI_CLIENT_DIV_ID} className={KAMBI_CSS_HIDDEN_CLASS} key='kambi-client' />
    </WrapperStyled>
  )
})

KambiClient.displayName = 'KambiClient'

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  maxWidth: `${measurements.mobi.maxWidth} !important`,
  margin: 'auto !important',

  [`&[data-hide-kambi-menu='true'] #${KAMBI_CLIENT_DIV_ID} .KambiBC-header__nav-btn--menu`]: {
    display: 'none !important',
  },

  [`&[data-hide-kambi-menu='true'] #${KAMBI_CLIENT_DIV_ID} .KambiBC-header-main__left`]: {
    display: 'none !important',
  },
})
